import { useContext } from 'react';
import { FieldPathId } from '@rjsf/utils';
import UWEFormContext from '../../../context/UWEFormContext';
import { setScrollYById } from '../../../util/scrolling';

/**
 * Switches the tab container this field lives in to the tab with the given key, then scrolls it
 * to the top. The field's own id minus its last segment is the container's id.
 */
export function useOpenScheduleTab(fieldPathId: FieldPathId) {
  const UweFormContext = useContext(UWEFormContext);
  const parentId = fieldPathId.$id
    .split('_')
    .slice(0, -1)
    .join('_');

  return (tabKey: string) => {
    UweFormContext?.setOpenTabs?.(prev => ({ ...prev, [parentId]: `${parentId}_${tabKey}` }));
    setTimeout(() => {
      setScrollYById(parentId, 0);
    }, 50);
  };
}
